import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loader"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Alert = _resolveComponent("Alert")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_PortalShell = _resolveComponent("PortalShell")!
  const _component_NNotificationProvider = _resolveComponent("NNotificationProvider")!
  const _component_NConfigProvider = _resolveComponent("NConfigProvider")!

  return (_openBlock(), _createBlock(_component_NConfigProvider, {
    class: "app-root",
    theme: _ctx.naiveTheme,
    "theme-overrides": _ctx.themeOverrides
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Alert),
      (_ctx.loading > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
            _createElementVNode("div", { class: "lds-dual-ring" }, null, -1)
          ]))]))
        : _createCommentVNode("", true),
      _createVNode(_component_NNotificationProvider, {
        max: 3,
        placement: "top-right"
      }, {
        default: _withCtx(() => [
          (_ctx.$route.meta.layout === "portal")
            ? (_openBlock(), _createBlock(_component_PortalShell, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_view)
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["theme", "theme-overrides"]))
}